<template>
  <div>
    <Header />

    <div class="container-fluid users-container">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <DivvyAdminSidebar />
        </div>

        <transition appear name="fade">
          <div class="col-md-9 right-container">
            <div class="col-md-12 pt-4">
              <!--  -->
              <div class="col-md-8 col-lg-6 border rounded p-2">
                <h3>Confirm deletion</h3>

                <p>Delete {{ Role }}?</p>
                <p>
                  <b>Please note:</b> Deleting this role means the following
                  users will no longer have rights to administrative scripts:
                </p>

                <p>No users found.</p>

                <button
                  type="button"
                  style="color: white;"
                  class="btn btn-danger"
                  @click="deleteRole"
                >
                  Delete
                </button>
                <router-link
                  class="btn btn-primary ml-2"
                  :to="{ name: 'DivvyAdminManageSecurityRoles' }"
                >
                  Cancel
                </router-link>
              </div>
              <!--  -->
            </div>
          </div>
        </transition>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import DivvyAdminSidebar from "@/views/divvyadmin/divvyAdminSidebar.vue";

export default {
  name: "DeleteSecurityRole",
  data() {
    return {
      Role: this.$route.params.role,
      Id: this.$route.params.id,
    };
  },
  components: {
    Header,
    Footer,
    DivvyAdminSidebar,
  },
  methods: {
    setActiveMenuItem: function() {
      this.$store.dispatch("divvyAdminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "manageRoles",
        activeMenu: this.activeMenu ? this.activeMenu : "security",
      });
    },
    deleteRole() {
      // const confirmation = confirm(
      //   `Are you sure you want to delete ${this.Role} role?`
      // );
      // if (!confirmation) return;
      this.$store
        .dispatch("manageRoles/deleteSecurityRole", { secid: this.Id })
        .then((data) => {
          this.$router.push({
            name: "DivvyAdminManageSecurityRoles",
          });
        });
    },
  },
  created() {
    this.setActiveMenuItem();
  },
};
</script>

<style lang="scss" scoped>
.users-container {
  min-height: 100%;
  margin: -14px 0 0 0;
}
</style>
